export default "__VITE_ASSET__BPws$_Nu__"